// src/components/Sidebar.js
import React, { useState, useEffect } from 'react';

const Sidebar = ({ setCurrentPage, currentPage }) => {
  const [openMenus, setOpenMenus] = useState({
    purchase: false,
    sales: false,
    reports: false
  });

  const menuItems = [
    { id: 'dashboard', name: 'داشبورد', icon: '📊', path: '/', type: 'single' },
    {
      id: 'purchase',
      name: 'فاکتور خرید',
      icon: '🛒',
      type: 'parent',
      subItems: [
        { id: 'purchaseList', name: 'لیست فاکتورها', icon: '📋', path: '/purchase-list' },
        { id: 'purchaseCreate', name: 'ثبت فاکتور جدید', icon: '✏️', path: '/purchase-create' }
      ]
    },
    {
      id: 'sales',
      name: 'فاکتور فروش',
      icon: '💰',
      type: 'parent',
      subItems: [
        { id: 'salesList', name: 'لیست فاکتورهای فروش', icon: '📋', path: '/sales-list' },
        { id: 'salesCreate', name: 'ثبت فاکتور فروش جدید', icon: '✏️', path: '/sales-create' },
        { id: 'salesReturn', name: 'فاکتورهای برگشتی', icon: '↩️', path: '/sales-return' }
      ]
    },
    {
      id: 'reports',
      name: 'گزارش‌گیری',
      icon: '📈',
      type: 'parent',
      subItems: [
        { id: 'dailyReport', name: 'گزارش روزانه', icon: '📅', path: '/daily-report' },
        { id: 'monthlyReport', name: 'گزارش ماهانه', icon: '📊', path: '/monthly-report' },
        { id: 'profitLoss', name: 'گزارش سود و زیان', icon: '💰', path: '/profit-loss' }
      ]
    }
  ];

  const handleMainClick = (item) => {
    if (item.type === 'parent') {
      setOpenMenus(prev => ({
        ...prev,
        [item.id]: !prev[item.id]
      }));
    } else if (item.path) {
      setCurrentPage(item.path); // الان مسیر است، مثلاً '/'
    } else {
      alert('این بخش در حال طراحی است.');
    }
  };

  const handleSubClick = (path) => {
    setCurrentPage(path); // الان مسیر است، مثلاً '/purchase-list'
  };

  // تشخیص فعال بودن آیتم اصلی
  const isActive = (item) => {
    if (item.type === 'single') {
      return currentPage === item.path;
    }
    return false;
  };

  // تشخیص فعال بودن زیرمنو
  const isSubActive = (subItem) => {
    return currentPage === subItem.path;
  };

  // باز کردن خودکار منوی والد اگر یکی از زیرمنوهایش فعال باشد
  useEffect(() => {
    const newOpenMenus = { ...openMenus };
    let changed = false;
    
    menuItems.forEach(item => {
      if (item.type === 'parent') {
        const shouldOpen = item.subItems.some(sub => currentPage === sub.path);
        if (shouldOpen && !openMenus[item.id]) {
          newOpenMenus[item.id] = true;
          changed = true;
        }
      }
    });
    
    if (changed) {
      setOpenMenus(newOpenMenus);
    }
  }, [currentPage]);

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <span className="logo-icon">📋</span>
        <span>سامانه حسابداری</span>
      </div>
      <ul className="sidebar-menu">
        {menuItems.map((item) => (
          <li key={item.id}>
            <div 
              className={`menu-item ${isActive(item) ? 'active' : ''}`} 
              onClick={() => handleMainClick(item)}
            >
              <span className="menu-icon">{item.icon}</span>
              <span>{item.name}</span>
              {item.type === 'parent' && (
                <span className="submenu-arrow">
                  {openMenus[item.id] ? '▲' : '▼'}
                </span>
              )}
            </div>
            
            {item.type === 'parent' && openMenus[item.id] && (
              <ul className="submenu">
                {item.subItems.map((sub) => (
                  <li 
                    key={sub.id} 
                    className={`${isSubActive(sub) ? 'active' : ''}`}
                    onClick={() => handleSubClick(sub.path)}
                  >
                    <span className="menu-icon">{sub.icon}</span>
                    <span>{sub.name}</span>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;